module.exports = __webpack_public_path__ + "media/images/flags/1x1/sdn-c40f390afd1bff5b69c9444d2fa99cb8.svg";